import { render, staticRenderFns } from "./kb-folder-card.vue?vue&type=template&id=661a5ad0&scoped=true"
import script from "./kb-folder-card.vue?vue&type=script&lang=js"
export * from "./kb-folder-card.vue?vue&type=script&lang=js"
import style0 from "./kb-folder-card.vue?vue&type=style&index=0&id=661a5ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661a5ad0",
  null
  
)

export default component.exports